import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { get } from "../../lib/request"
import { normalizeDailyPostStatsPayload } from "../../lib/utils/dailyPostStatsReport"
import {
  beginPulseFetch,
  isStalePulseFetch,
} from "../../lib/utils/pulseApiRows"
import { skipIfClientLoaded } from "../utils/fetchDedupe"

/**
 * GET /api/v1/posts/clients/{clientId}/report/daily/stats
 */
export const fetchDailyPostStats = createAsyncThunk(
  "dailyPostStats/fetch",
  async ({ clientId } = {}, { rejectWithValue }) => {
    try {
      if (clientId == null || clientId === "") {
        return rejectWithValue("clientId is required")
      }

      const data = await get(`posts/clients/${clientId}/report/daily/stats`)

      return {
        rows: normalizeDailyPostStatsPayload(data),
        clientId: String(clientId),
      }
    } catch (err) {
      return rejectWithValue(err?.message || "Failed to fetch daily post stats")
    }
  },
  {
    condition: (arg, { getState }) => {
      return !skipIfClientLoaded(getState().dailyPostStats, arg?.clientId)
    },
  },
)

const initialState = {
  rows: [],
  status: "idle",
  error: null,
  requestedClientId: null,
  fetchedClientId: null,
}

const dailyPostStatsSlice = createSlice({
  name: "dailyPostStats",
  initialState,
  reducers: {
    clearDailyPostStats: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDailyPostStats.pending, (state, action) => {
        beginPulseFetch(state, action)
      })
      .addCase(fetchDailyPostStats.fulfilled, (state, action) => {
        if (isStalePulseFetch(action, state)) return
        state.status = "succeeded"
        state.rows = action.payload?.rows ?? []
        state.fetchedClientId = action.payload?.clientId ?? null
      })
      .addCase(fetchDailyPostStats.rejected, (state, action) => {
        if (isStalePulseFetch(action, state)) return
        state.status = "failed"
        state.error = action.payload ?? "Failed to fetch daily post stats"
        state.rows = []
        state.fetchedClientId = state.requestedClientId
      })
  },
})

export const { clearDailyPostStats } = dailyPostStatsSlice.actions
export default dailyPostStatsSlice.reducer
